import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classes from './limited-edition-in-stock.scss';
import animationClasses from './appear.anim.scss';
export let LimitedEditionInStockStyle = /*#__PURE__*/function (LimitedEditionInStockStyle) {
  LimitedEditionInStockStyle["Big"] = "big";
  LimitedEditionInStockStyle["FullWidth"] = "fullWidth";
  return LimitedEditionInStockStyle;
}({});
const switchStyles = style => {
  switch (style) {
    case LimitedEditionInStockStyle.Big:
      return classes.wrapperBig;
    case LimitedEditionInStockStyle.FullWidth:
      return classes.wrapperFullWidth;
    default:
      return classes.wrapperBig;
  }
};
export const LimitedEditionInStockComponent = ({
  style,
  inStock,
  hideLEInStock
}) => {
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: !hideLEInStock,
    timeout: 300,
    classNames: animationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: switchStyles(style)
  }, "Only ", /*#__PURE__*/React.createElement("span", null, "\xA0", inStock, "\xA0"), " in stock"));
};